import React, { useRef, useState } from "react";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import { Dimmer } from "../components/spinner";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { Mensaje } from "../components/mensajes";
import useTableScroll from "../components/useTableScroll.js";

const CatalogoTimbres = (props) => {
  const op = require("../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));

  const btnCancela = useRef();
  const [activate, setActivate] = useState(false);
  const [values, setValues] = useState({});
  const [itemSelect, setItemSelect] = useState(-1);
  const [records, setRecords] = useState([]);
  const [activo, setActivo] = useState(true);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const headCells = [
    { label: "TIMBRE", textAlign: "center" },
    { label: "VALOR UTE", textAlign: "center" },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableScroll(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idtimbredetalle.includes(target.value) ||
              x.ut.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarRegistros = () => {
    let endpoint = `${op.conexion}/api/timbres`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setActivate(false);

          setRecords(response.data);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const blanquear = () => {
    setActivate(false);
    setRecords([]);
    setItemSelect("");
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
    setActivo(true);
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelaCat();
  };

  const seleccionarTimbre = (index) => (event) => {
    event.preventDefault();

    var status = values[0].status;
    var idplanilla = values[0].idplanilla;
    var idtimbre = values[0].idtimbre;
    var valorUTE = values[0].valorUTE;

    blanquear();
    props.infoCatalogo(idtimbre, idplanilla, status, valorUTE);
  };

  const seleccionarFila = (index) => (event) => {
    setItemSelect(index);
    setActivo(false);
    var status = recordsAfterPagingAndSorting()[index].estatustimbre;
    var idplanilla = recordsAfterPagingAndSorting()[index].idplanillatimbre;
    var idtimbre = recordsAfterPagingAndSorting()[index].idtimbredetalle;
    var valorUTE = recordsAfterPagingAndSorting()[index].ut;

    var datos = [];
    datos.push({
      idplanilla,
      idtimbre,
      status,
      valorUTE,
    });
    setValues(datos);
  };

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarRegistros();
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>Timbres Fiscales</h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
          }}
        />
        <Dimmer active={activate} />
        <div className="row col-md-12" style={{ marginBottom: "2px" }}>
          <div className="input-group col-md-4 input-group-sm mb-3">
            <input
              type="text"
              onChange={handleSearch}
              className="form-control"
            />
            <button className="btn btn-info" style={{ pointerEvents: "none" }}>
              <i className="fa fa-search"></i>
            </button>
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer>
            <TblHead />

            <TableBody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <TableRow
                    key={index}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      background:
                        itemSelect === index ? "lightskyblue" : "white",
                    }}
                    onClick={seleccionarFila(index)}
                  >
                    <TableCell className="py-2 text-start">
                      {item.idtimbredetalle}
                    </TableCell>
                    <TableCell className="py-2 text-end">{item.ut}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-success rounded-pill"
          disabled={activo}
          style={{ margin: "5px" }}
          onClick={seleccionarTimbre()}
        >
          <i className="fas fa-check-circle"> Aceptar</i>{" "}
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CatalogoTimbres;



// WEBPACK FOOTER //
// ./src/catalogos/catalogoTimbres.js